export default "__VITE_PUBLIC_ASSET__416538e7__"